import { FC } from 'react'
import ApplicationResponsiveModal from '../common/ApplicationResponsiveModal'

type ThisIsntMeProps = {
  onClick: () => void
  onClose: () => void
  message?: string | null
  isDeclining: boolean
}

const ThisIsntMeModal: FC<ThisIsntMeProps> = ({ onClick, onClose, message, isDeclining }: ThisIsntMeProps ) => {
    return (
        <ApplicationResponsiveModal
            ariaLabelledBy='application-thisisntme-title'
            closeAriaLabel='Close This isnt me modal'
            onClose={onClose}
            modalClassName='application-helper-modal'
            closeButtonClassName='application-helper-modal-close'
            hideCloseButtonOnMobile
            mobileAnimationMs={380}
        >
            <div className='this-isnt-me-modal'>
                <div className='head'>
                    <h2>Is this not really you?</h2>
                    <p>You're about to decline this invitation and report it as something you don't recognise.</p>
                </div>
                <div className='this-isnt-me'>
                    <div className='inner'>
                        <label className='m0'>
                            Are you sure this invitation wasn't meant for you?
                        </label>
                    </div>
                    <button type='button' className='continue-decline mt-5' onClick={onClick} disabled={isDeclining}>
                        {isDeclining ? 'Declining...' : `Yes, this isn't me`}
                    </button>
                    <button type='button' className='back' onClick={onClose}>
                        ← Back
                    </button>
                </div>
                {message && (
                    <div className='text-danger small mt-3' role='alert'>
                        {message}
                    </div>
                )}
            </div>
        </ApplicationResponsiveModal>
    )
}

export default ThisIsntMeModal;
